module.exports = __webpack_public_path__ + "img/1200-800-main.361767fd.png";